module.exports = __webpack_public_path__ + "static/media/export_icon.9586abff.svg";